export const LikeIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
			<path
				d="M13.3687 33.2632V16.2105L27.5792 2C27.5792 2 30.4213 2 29.4739 7.68421C28.5265 13.3684 26.6318 15.2632 26.6318 15.2632H35.0508C36.5416 15.2632 37.629 16.6738 37.2496 18.1155L33.9325 30.7206C33.5382 32.2189 32.1836 33.2632 30.6343 33.2632H13.3687Z"
				fill="#4A4A4A"
			/>
			<path
				d="M13.3687 33.2632V16.2105L27.5792 2C27.5792 2 30.4213 2 29.4739 7.68421C28.5265 13.3684 26.6318 15.2632 26.6318 15.2632H35.0508C36.5416 15.2632 37.629 16.6738 37.2496 18.1155L33.9325 30.7206C33.5382 32.2189 32.1836 33.2632 30.6343 33.2632H13.3687Z"
				fill="url(#paint0_linear_169_209)"
			/>
			<path d="M2 16.2104H13.3684V37.0526C7.08982 37.0526 2 31.9627 2 25.6841V16.2104Z" fill="#262A2F" />
			<defs>
				<linearGradient
					id="paint0_linear_169_209"
					x1="20.9476"
					y1="11.0947"
					x2="41.4879"
					y2="29.3359"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#568DFE" />
					<stop offset="1" stopColor="#D4E2FC" />
				</linearGradient>
			</defs>
		</svg>
	)
}
